module.exports = __webpack_public_path__ + "static/media/building4.29e3da0d.png";